module.exports = __webpack_public_path__ + "img/csr_111123_C.4939360f.jpg";